'use client'

import { CategoryContent } from 'modules/Category/features/CategoryContent/Desktop'

export default function Desktop() {
  return <CategoryContent />
}
